import ModeShippingWizard from "./modeShippingWizard.js"
import StringUtils from "../utils/string.js"

export default class HomeShippingWizard extends ModeShippingWizard {

  constructor($container, options) {
    super($container, options);

    this.$container.html(`
        <table>
          <tbody>
            <tr>
              <td></td>
            </tr>
          </tbody>
        </table>
      `);

    this.$list = $('<ul/>', { class: 'home-modes' }).appendTo(this.$container.find('> table > tbody > tr > td').first());
    this.$address = $([]);
  }

  update(modeDetails, options) {
    // the shipping must be choosen in dumb list
    this.$list.empty();
    for (let offer of modeDetails.offers) {
      let $choice = $('<li/>')
        .appendTo(this.$list)
        .click(event => {
          this.selectCarrier(offer, $choice)
        });

      $choice.html(`
          <div class="mode">
             <span class="checkbox"/>
            <span class="name"><img src="${this.settings.ressources.images[offer.type] != undefined ? require('../../images/interface/default/livraison/' + this.settings.ressources.images[offer.type]) : ''}" alt="${offer.provider}"/></span>
            <span class="availability">Livraison ${offer.deliverDateLabel}</span>
            <span class="cost">${offer.cost.total > 0 ? StringUtils.toLocaleString(offer.cost.total, { style: 'currency', currency: 'EUR' }) : ' Gratuit'}</span>
          </div>
          <div class="address"></div>
        `);
    }

    this.$address = this.$list.find('.address')
    this.$address.empty();
    if (this.currentAddress.id) {
      this.$address.html(`
          <i class="fa fa-home"></i>
          <h4>
            <span class="firstname">${this.currentAddress.firstname}</span>
            <span class="lastname">${this.currentAddress.lastname}</span>
          </h4>
          <p class="address">
            <span class="street">${this.currentAddress.street}</span><br/>
            <span class="cp">${this.currentAddress.cp}</span>
            <span class="ville">${this.currentAddress.town}</span>
          </p>
        `);
    } else {
      this.$address.html(`
          <h4 class="fixed">À l'adresse du détenteur de la liste de naissance</h4>
        `)
    }
  }

  resetSelection() {
    this.$list.find(' > li.selected').removeClass('selected');
  }

  selectCarrier(offer, $choice) {
    this.resetSelection();
    $choice.addClass('selected');
    //    this.addressChanged = false;
    const shipping = document.querySelector('.contenu.adresses')
    shipping.setAttribute('data-shipping', offer.type)

    if (shipping.classList.contains('shipping-selected')) {
      window.dispatchEvent(new Event('selectModifyShipping'))
    } else {
      window.dispatchEvent(new Event('selectShipping'))
      shipping.classList.add('shipping-selected')
    }

    super.on('select', offer, $choice);
  }
}
